import { SearchResult } from './search-result.do';
import { TrackAndTrace } from './track-and-trace.do';

export class ExternalSearchResult  extends SearchResult {
    resource: TrackAndTrace;


  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'resource':
        return new TrackAndTrace(propertyValue);
      default:
        return returnValue;
    }
  }
}
